<template>
    <div class="col-12 box-margin height-card">

        <div class="card">
            <div class="card-header">
                <div class="btn-group" role="group">
                    <router-link  :to="'/tratar-datos-clientes'" type="button"  class="btn btn-primary">
                    <i class="far fa-arrow-alt-circle-left"></i> Regresar
                    </router-link>
                </div>
                <i class="fas fa-file-invoice"></i><span> Editar</span>
            </div>
            <div class="card-body">
                <form>

                    <div class="row">
                        <div class="col-sm-4">
                            <label>Cliente:</label>

                            <input type="text" class="form-control bloquear"  v-model="nombre_cliente" id="cliente" v-if="cliente_estado">

                            <div class="input-group col-xs-12" v-else>
                                <input type="text" class="form-control bloquear" placeholder="Sin Cliente">
                                <span class="input-group-append">
                                    <button class=" btn btn-primary" type="button" @click="abrirModalTipoCliente()">Agregar</button>
                                </span>
                            </div>
                        </div>

                        <div class="col-sm-4">
                            <div class="form-group">
                                <label class="control-label">Asesor:</label>
                                <el-select class="bjar" v-model="form.user_id" filterable placeholder="Seleccionar">
                                    <el-option  v-for="item in lista_users" :key="item.id" :label="item.fullname" :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <div class="col-sm-4">
                            <div class="form-group">
                                <label class="control-label">Referencia:</label>
                                <el-select class="bjar" v-model="form.referencia_id" filterable placeholder="Seleccionar">
                                    <el-option  v-for="item in lista_referencias" :key="item.id" :label="item.nombre" :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <div class="col-sm-4">
                            <div class="form-group">
                                <label class="control-label">Seguro:</label>
                                <el-select class="bjar" v-model="form.seguro_id" filterable placeholder="Seleccionar">
                                    <el-option  v-for="item in lista_seguros" :key="item.id" :label="item.nombre" :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <div class="col-sm-4">
                            <div class="form-group">
                                <label class="control-label">Estado:</label>
                                <select class="custom-select" v-model="form.estado">
                                    <option value="NO CONTACTADO">No contactado</option>
                                    <option value="NÚMERO INCORRECTO">Número incorrecto</option>
                                    <option value="EN GESTIÓN">En gestión</option>
                                    <option value="PROSPECTO">Prospecto</option>
                                </select>
                            </div>
                        </div>

                        <div class="col-sm-4">
                            <div class="form-group">
                                <label class="control-label">Teléfono 1:</label>
                                <input type="text" class="form-control"  v-model="form.telefono_1">
                            </div>
                        </div>

                        <div class="col-sm-4">
                            <div class="form-group">
                                <label class="control-label">Teléfono 2:</label>
                                <input type="text" class="form-control"  v-model="form.telefono_2">
                            </div>
                        </div>

                        <div class="col-sm-4">
                            <div class="form-group">
                                <label class="control-label">Modelo:</label>
                                <el-select class="bjar" v-model="form.vehiculo_id" filterable placeholder="Seleccionar">
                                    <el-option  v-for="item in lista_vehiculos" :key="item.id" :label="item.nombre" :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <div class="col-sm-4">
                            <div class="form-group">
                                <label class="control-label">Año:</label>
                                <el-select class="bjar" @change="asignarAnio($event)" v-model="form.anio" filterable placeholder="Seleccionar">
                                    <el-option  v-for="item in lista_anios" :key="item.id" :label="item.anio" :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <div class="col-sm-4">
                            <div class="form-group">
                                <label class="control-label">Años antiguedad:</label>
                                <input type="number" @input="asignarTasa()" class="form-control"  v-model="form.anio_antiguedad">
                            </div>
                        </div>

                        <div class="col-sm-4">
                            <div class="form-group">
                                <label class="control-label">Placa:</label>
                                <input type="text" class="form-control"  v-model="form.placa">
                            </div>
                        </div>

                        <div class="col-sm-4">
                            <div class="form-group">
                                <label class="control-label">Suma Asegurada:</label>
                                <money  v-bind="money" @input="asignarTasa()" v-model="form.valor_asgurado"  class="form-control"></money>
                            </div>
                        </div>

                        <div class="col-sm-4">
                            <div class="form-group">
                                <label class="control-label">Tasa %:</label>
                                <money  v-bind="porcentaje_mo" v-model="form.tasa"  class="form-control"></money>
                            </div>
                        </div>

                        <div class="col-sm-4">
                            <div class="form-group">
                                <label class="control-label">Vigencia Inicio: </label>
                                <input type="date" v-model="form.fecha_inicio" class="form-control">
                            </div>
                        </div>

                        <div class="col-sm-4">
                            <div class="form-group">
                                <label class="control-label">Vigencia Fin: </label>
                                <input type="date" v-model="form.fecha_fin" class="form-control">
                            </div>
                        </div>

                        <div class="col-sm-4">
                            <div class="form-group">
                                <label class="control-label">Comentario: </label>
                                <el-input
                                    type="textarea"
                                    placeholder="Comentario"
                                    v-model="form.comentario"
                                    maxlength="255"
                                    :autosize="{ minRows: 1.3, maxRows: 4}"
                                    clearable
                                    show-word-limit
                                    >
                                </el-input>
                            </div>
                        </div>


                    </div><!-- Row -->

                </form>
                    <button @click="guardar()" type="button" class="btn btn-primary submit">Guardar</button>
            </div>
        </div>

        <!-- Tipo cliente -->
        <div class="modal fade " :class="{ show: modal_show_tipo_cliente }" :style=" modal_show_tipo_cliente ? mostrarModal : 'ocultarModal'" >
            <div class="modal-dialog modal-md modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title mt-0 font-16" id="myLargeModalLabel" >Seleccionar tipo de Registro</h4>
                        <button type="button" @click="abrirModalTipoCliente" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12 form-group">
                                <button type="button" class="btn btn-primary  btn-block" @click="abrirModalNatural(),abrirModalTipoCliente()">Natural</button>
                            </div>

                            <div class="col-md-12 form-group">
                                <button type="button" class="btn btn-primary  btn-block" @click="abrirModalJuridica(),abrirModalTipoCliente()">Juridico</button>
                            </div>

                        </div>
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-secondary" @click="abrirModalTipoCliente">Cerrar</button>
                    </div>

                </div>
            </div>
        </div>

        <!-- Cliente natural -->
        <div class="modal fade " :class="{ show: modalShowNatural }" :style=" modalShowNatural ? mostrarModal : 'ocultarModal'" >
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title mt-0 font-16" id="myLargeModalLabel" v-text="tituloModal"></h5>
                        <button type="button" @click="abrirModalNatural" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    </div>
                    <div class="modal-body">
                       <form >
                           <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="LeadName">Nombre</label>
                                        <input type="text" class="form-control" id="name" v-model="vaCreCliente.cNombre" placeholder="Ingresa Nombre del Cliente">
                                    </div>
                                </div>
                                 <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="LeadName">Apellido</label>
                                        <input type="text" class="form-control" id="apellido" v-model="vaCreCliente.cApellido" placeholder="Ingresa Apellido del Cliente">
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="status-select" class="mr-2">Documento</label>
                                        <select class="custom-select" v-model="vaCreCliente.eIdDocumento" id="status-select">
                                            <option v-for="doc in lista_documentos" :key="doc.id" :value="doc.id" v-text="doc.tipo_doc"></option>
                                        </select>
                                    </div>
                                </div>
                                 <div class="col-md-4">
                                            <div class="form-group">
                                                <label for="usuarios">N° Documento</label>
                                                <input type="text" class="form-control" v-model="vaCreCliente.cNumDoc" placeholder="Ingrese número de documento">
                                            </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="LeadName">Dirección</label>
                                        <input type="text" class="form-control" id="direccion" v-model="vaCreCliente.cDireccion" placeholder="Ingrese una Dirección">
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="LeadName">Correo Electrónico</label>
                                        <input type="text" class="form-control" id="correo" v-model="vaCreCliente.cEmail" placeholder="Ingresa un Correo Electrónico">
                                    </div>
                                </div>

                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="LeadName">Teléfono </label>
                                        <input type="text" class="form-control" v-model="vaCreCliente.cTelefonoCliente" placeholder="Ingrese un Nº de Teléfono">
                                    </div>
                                </div>

                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="LeadName">Fecha Nacimiento </label>
                                        <input type="date" class="form-control" v-model="vaCreCliente.fecha_nacimiento" >
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="status-select" class="mr-2">Referencias</label>
                                        <select class="custom-select" v-model="vaCreCliente.referencia" id="status-select">
                                            <option v-for="red in lista_referencias" :key="red.id" :value="red.id" v-text="red.nombre"></option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="status-select" class="mr-2">Actividad Economica</label>
                                        <select class="custom-select" v-model="vaCreCliente.idactividad_economica" id="status-select">
                                            <option v-for="red in lista_acti_econo" :key="red.id" :value="red.id" v-text="red.nombre"></option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="LeadName">Nombre Conyugue</label>
                                        <input type="text" class="form-control" id="name_conyugue" v-model="vaCreCliente.nombre_conyugue" placeholder="Ingresa Nombre del Conyugue">
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="LeadName">Apellido Conyugue</label>
                                        <input type="text" class="form-control" id="apellido_conyugue" v-model="vaCreCliente.apellido_conyugue" placeholder="Ingresa Apellido del Conyugue">
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="status-select" class="mr-2">Estado Civil</label>
                                        <select class="custom-select" v-model="vaCreCliente.estado_civil" id="status-select">

                                            <option value="Soltero">Soltero</option>
                                            <option value="Casado">Casado</option>
                                            <option value="Divorciado">Divorciado</option>
                                            <option value="Unión libre">Unión libre</option>

                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="LeadName">Fecha Nacimiento Conyugue</label>
                                        <input type="date" class="form-control" v-model="vaCreCliente.fecha_nacimiento_conyugue" >
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label for="LeadName">Cantidad de Hijos</label>
                                        <input type="number" min="0" class="form-control" id="hijos" v-model="vaCreCliente.hijos_cantidad">
                                    </div>
                                </div>

                                <div class="col-md-2 bloquear">
                                    <div class="form-group">
                                        <label for="LeadName">Edad Conyugue</label>
                                        <input type="text" class="form-control" id="edad_conyugue" :value="calcularEdad(vaCreCliente.fecha_nacimiento_conyugue)">
                                    </div>
                                </div>

                            </div>
                        </form>

                        <form class="g-brd-around g-brd-gray-light-v4">
                             <h4>Nombre de los Hijos</h4>
                            <hr class="g-brd-gray-light-v4 g-mx-minus-30">
                            <div class="row" >
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="LeadName">Nombre</label>
                                        <input type="text" class="form-control" id="name_hijo" v-model="dataHijosConyugues.nombre" placeholder="Ingresar Nombre">
                                    </div>
                                </div>
                                 <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="LeadName">Apellido</label>
                                        <input type="text" class="form-control" id="apellido_hijo" v-model="dataHijosConyugues.apellido" placeholder="Ingresar Apellido">
                                    </div>
                                </div>
                                 <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="LeadName">Fecha Nacimiento </label>
                                        <input type="date" class="form-control" v-model="dataHijosConyugues.fecha_nacimiento" >
                                    </div>
                                </div>
                                 <div class="col-md-12 text-right">
                                   <button type="button" class="btn btn-success mb-2 mr-2" @click="agregarHijosConyugue()">Agregar</button>
                                </div>
                            </div>
                            <div class="table-responsive" style="padding-top: 10ox">
                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th >Eliminar</th>
                                            <th>Nombre</th>
                                            <th>Apellido</th>
                                            <th>Cumpleaños</th>
                                            <th>Edad</th>
                                        </tr>
                                    </thead>

                                    <tbody v-if="listHijosConyugue.length">
                                        <tr v-for="(c, index) in listHijosConyugue" :key="index">
                                            <td >
                                                <button type="button" @click="eliminar_hijo(index)" class="btn btn-danger btn-block"><i class="fas fa-trash-alt"></i> Quitar</button>
                                            </td>
                                            <td >
                                                <input type="text" class="form-control" v-model="c.nombre" placeholder="Ingresar Nombre">
                                            </td>
                                            <td>
                                                 <input type="text" class="form-control" v-model="c.apellido" placeholder="Ingresar Apellido">
                                            </td>
                                            <td >
                                                 <input type="date" class="form-control" v-model="c.cumpleanio" >
                                            </td>
                                            <td>{{calcularEdad(c.cumpleanio)}} Años</td>
                                        </tr>
                                    </tbody>
                                     <tbody v-else>
                                        <tr>
                                            <td :colspan="9" align="center">
                                                <h5>No se encontraron resultados...</h5>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </form>
                    </div>

                     <div class="modal-footer">
                            <button type="button" class="btn btn-sm btn-primary" @click="setRegistrarCliente" v-text="nameButon"></button>
                            <button type="button" class="btn btn-sm btn-secondary" @click="abrirModalNatural">Cerrar</button>
                     </div>

                </div><!-- /.modal-content -->
            </div><!-- /.modal-dialog -->
        </div>

         <!--   Inicio modal jurudica-------------------------------------------------------------->
        <div class="modal fade " :class="{ show: modalShowJuridica }" :style=" modalShowJuridica ? mostrarModal : 'ocultarModal'" >
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title mt-0 font-16" id="myLargeModalLabel" v-text="tituloModal_juri">  </h4>
                        <button type="button" @click="abrirModalJuridica()" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    </div>
                    <div class="modal-body">
                        <h5>Datos Generales</h5>
                        <hr class="g-brd-gray-light-v4 g-mx-minus-0">
                        <div class="row" >
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="LeadName">Razón Social</label>
                                    <input type="text" class="form-control" id="name" v-model="crear_cliente_juridico.razon_social" placeholder="Ingresar razón social">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="LeadName">Ruc</label>
                                    <input type="text" class="form-control" id="name" v-model="crear_cliente_juridico.ruc" placeholder="Ingresar ruc">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="status-select" class="mr-2">Documento</label>
                                    <select class="custom-select" v-model="crear_cliente_juridico.id_documento" id="status-select">
                                         <option value="0">Seleccionar</option>
                                        <option v-for="doc in lista_documentos" :key="doc.id" :value="doc.id" v-text="doc.tipo_doc"></option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="LeadName">Dirección</label>
                                    <input type="text" class="form-control" id="direccion" v-model="crear_cliente_juridico.direccion" placeholder="Ingrese una dirección">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="LeadName">Correo Electrónico</label>
                                    <input type="text" class="form-control" id="correo" v-model="crear_cliente_juridico.correo" placeholder="Ingrese un correo electrónico">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="LeadName">Teléfono 1</label>
                                    <input type="text" class="form-control" v-model="crear_cliente_juridico.telefono_1" placeholder="Ingrese un Nº de Teléfono">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="LeadName">Teléfono 2</label>
                                    <input type="text" class="form-control" v-model="crear_cliente_juridico.telefono_2" placeholder="Ingrese un Nº de Teléfono">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="LeadName">Fecha de Constitución</label>
                                    <input type="date" class="form-control" v-model="crear_cliente_juridico.fecha_constitucion" >
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="status-select" class="mr-2">Actividad Economica</label>
                                    <select class="custom-select" v-model="crear_cliente_juridico.id_actividad_economica" id="status-select">

                                        <option v-for="red in lista_acti_econo" :key="red.id" :value="red.id" v-text="red.nombre"></option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="status-select" class="mr-2">Referencia</label>
                                    <select class="custom-select" v-model="crear_cliente_juridico.id_referencia" id="status-select">

                                        <option v-for="red in lista_referencias" :key="red.id" :value="red.id" v-text="red.nombre"></option>
                                    </select>
                                </div>
                            </div>

                        </div>
                        <h5>Datos del Representante Legal</h5>
                        <hr class="g-brd-gray-light-v4 g-mx-minus-0">
                        <div class="row" >
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="LeadName">Nombre</label>
                                    <input type="text" class="form-control" id="name" v-model="crear_representante_legal.nombre" placeholder="Ingrese nombre">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="LeadName">Apellido</label>
                                    <input type="text" class="form-control" id="apellido" v-model="crear_representante_legal.apellido" placeholder="Ingrese apellido">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="status-select" class="mr-2">Documento</label>
                                    <select class="custom-select" v-model="crear_representante_legal.id_documento" id="status-select_2">

                                        <option v-for="doc in lista_documentos" :key="doc.id" :value="doc.id" v-text="doc.tipo_doc"></option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="LeadName">Número de documento</label>
                                    <input type="text" class="form-control" id="apellido" v-model="crear_representante_legal.documento" placeholder="Ingrese apellido">
                                </div>
                            </div>

                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="LeadName">Dirección</label>
                                    <input type="text" class="form-control" id="direccion" v-model="crear_representante_legal.direccion" placeholder="Ingrese una dirección">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="LeadName">Correo Electrónico</label>
                                    <input type="text" class="form-control" id="correo" v-model="crear_representante_legal.correo" placeholder="Ingrese un correo electrónico">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="LeadName">Teléfono 1</label>
                                    <input type="text" class="form-control" v-model="crear_representante_legal.telefono_1" placeholder="Ingrese un Nº de Teléfono">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="LeadName">Teléfono 2</label>
                                    <input type="text" class="form-control" v-model="crear_representante_legal.telefono_2" placeholder="Ingrese un Nº de Teléfono">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="LeadName">Fecha de Nacimiento</label>
                                    <input type="date" class="form-control" v-model="crear_representante_legal.fecha_nacimiento" >
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="status-select" class="mr-2">Estado Civil</label>
                                    <select class="custom-select" v-model="crear_representante_legal.estado_civil" id="status-select_3">
                                        <option value="Soltero">Soltero</option>
                                        <option value="Casado">Casado</option>
                                        <option value="Divorciado">Divorciado</option>
                                        <option value="Unión libre">Unión libre</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <h5>Datos del Cónyuge</h5>
                        <hr class="g-brd-gray-light-v4 g-mx-minus-0">
                        <div class="row" >
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="LeadName">Nombre Conyugue</label>
                                    <input type="text" class="form-control" id="name_conyugue" v-model="crear_cliente_juridico.nombre_conyugue" placeholder="Ingresa Nombre del Conyugue">
                                </div>
                            </div>
                            <div class="col-md-4">
                               <div class="form-group">
                                   <label for="LeadName">Apellido Conyugue</label>
                                   <input type="text" class="form-control" id="apellido_conyugue" v-model="crear_cliente_juridico.apellido_conyugue" placeholder="Ingresa Apellido del Conyugue">
                               </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="LeadName">Fecha Nacimiento Conyugue</label>
                                    <input type="date" class="form-control" v-model="crear_cliente_juridico.fecha_nacimiento_conyugue" >
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label for="LeadName">Cantidad de Hijos</label>
                                    <input type="number"  min="0" class="form-control" id="hijos" v-model="crear_cliente_juridico.hijos_cantidad">
                                </div>
                            </div>
                            <div class="col-md-2 bloquear">
                                <div class="form-group">
                                    <label for="LeadName">Edad Conyugue</label>
                                    <input type="text" class="form-control" id="edad_conyugue" :value="calcularEdad(crear_cliente_juridico.fecha_nacimiento_conyugue)">
                                </div>
                            </div>
                        </div>

                        <h5>Nombre de los Hijos</h5>
                        <hr class="g-brd-gray-light-v4 g-mx-minus-0">
                        <div class="row"  >
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="LeadName">Nombre</label>
                                        <input type="text" class="form-control" id="name_hijo" v-model="dataHijosConyugues.nombre" placeholder="Ingresar Nombre">
                                    </div>
                                </div>
                                 <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="LeadName">Apellido</label>
                                        <input type="text" class="form-control" id="apellido_hijo" v-model="dataHijosConyugues.apellido" placeholder="Ingresar Apellido">
                                    </div>
                                </div>
                                 <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="LeadName">Fecha Nacimiento </label>
                                        <input type="date" class="form-control" v-model="dataHijosConyugues.fecha_nacimiento" >
                                    </div>
                                </div>
                                 <div class="col-md-12 text-right">
                                   <button type="button" class="btn btn-success mb-2 mr-2" @click="agregarHijosConyugue()">Agregar</button>
                                </div>
                        </div>
                        <div class="table-responsive" style="padding-top: 10ox">
                                <table class="table table-bordered" >
                                    <thead>
                                        <tr>
                                            <th>Eliminar</th>
                                            <th>Nombre</th>
                                            <th>Apellido</th>
                                            <th>Cumpleaños</th>
                                            <th>Edad</th>
                                        </tr>
                                    </thead>

                                    <tbody v-if="listHijosConyugue.length">
                                        <tr v-for="(c, index) in listHijosConyugue" :key="index">
                                            <td >
                                                <button type="button" @click="eliminar_hijo(index)" class="btn btn-danger btn-block"><i class="fas fa-trash-alt"></i> Quitar</button>
                                            </td>
                                            <td >
                                                <input type="text" class="form-control" v-model="c.nombre" placeholder="Ingresar Nombre">
                                            </td>
                                            <td>
                                                 <input type="text" class="form-control" v-model="c.apellido" placeholder="Ingresar Apellido">
                                            </td>
                                            <td >
                                                 <input type="date" class="form-control" v-model="c.cumpleanio" >
                                            </td>
                                            <td>{{calcularEdad(c.cumpleanio)}} Años</td>
                                        </tr>
                                    </tbody>
                                    <tbody v-else>
                                        <tr>
                                            <td :colspan="9" align="center">
                                                <h5>No se encontraron resultados...</h5>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                        </div>

                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-primary" @click="setRegistrarClienteJuridico" >Guardar</button>
                        <button type="button" class="btn btn-sm btn-secondary" @click="abrirModalJuridica()">Cerrar</button>
                    </div>

                </div><!-- /.modal-content -->
            </div><!-- /.modal-dialog -->
        </div>
        <!--   Fin modal jurudica-------------------------------------------------------------->

    </div>
</template>

<script>
import {alertasM} from '../../../../util.js';

export default {
    mixins: [alertasM],
    data(){
        return {
            lista_seguros       : [],
            lista_referencias   : [],
            lista_users         : [],
            lista_vehiculos     : [],
            lista_anios         : [],
            lista_clientes      : [],
            lista_documentos    : [],
            lista_acti_econo    : [],
            cliente_estado  : false,
            //Cliente
            modal_show_tipo_cliente : false,
            mostrarModal: {
                display: 'block',
                background: '#0000006b'
            },
            ocultarModal: {
                display: 'none'
            },
            modalShowNatural    : false,
            modalShowJuridica   : false,

            form        : {
                vehiculo_id     : null,
                seguro_id       : null,

                user_id         : null,
                referencia_id   : null,
                estado          : 'NO CONTACTADO',
                telefono_1      : '',
                telefono_2      : '',
                anio_antiguedad : 0,
                fecha_inicio    : null,
                fecha_fin       : null,
                comentario      : '',

                anio_id         : null,
                anio            : '',
                placa           : '',
                valor_asgurado  : '',
                tasa            : '',
                edad            : 0,
            },
            nombre_cliente      : '',

            money: {
                    decimal: ',',
                    thousands: '.',
                    prefix: '$ ',
                    suffix: '',
                    precision: 2,
                    masked: false
            },

            porcentaje_mo: {
                    decimal: '.',
                    thousands: '',
                    prefix: '',
                    suffix: ' %',
                    precision: 2,
                    masked: false
            },
            //-----------------------------

            tituloModal      : 'Registrar',
            actu_reg         : 1,
            nameButon        : 'Guardar',

            vaCreCliente:{
                eId: 0,
                cNombre: '',
                cApellido: '',
                fecha_nacimiento: null,
                cNumDoc: '',
                eIdDocumento: 1,
                cDireccion: '',
                cTelefonoCliente: '',
                cEmail: '',
                referencia: 0,
                idactividad_economica: 0,
                estado_civil: '',
                hijos_cantidad: 0 ,
                nombre_conyugue: '',
                apellido_conyugue: '',
                fecha_nacimiento_conyugue: null,
                tipo                      : 1
            },
            crear_cliente_juridico:{
                id                          : 0,
                razon_social                : '',
                ruc                         : '',
                direccion                   : '',
                correo                      : '',
                id_documento                : 3,
                telefono_1                  : '',
                telefono_2                  : '',
                fecha_constitucion          : null,
                id_actividad_economica      : 0,
                id_referencia               : 0,
                tipo                        : 2,
                nombre_conyugue             : '',
                apellido_conyugue           : '',
                fecha_nacimiento_conyugue   : null,
                hijos_cantidad              : 0
            },
            crear_representante_legal: {
                id                  : '',
                nombre              : '',
                apellido            : '',
                documento           : '',
                id_documento        : 0,
                direccion           : '',
                correo              : '',
                telefono_1          : '',
                telefono_2          : '',
                fecha_nacimiento    : null,
                estado_civil        : '',

            },
            dataHijosConyugues:{
                id: 0,
                nombre: '',
                apellido: '',
                fecha_nacimiento: null
            },
            tituloModal_juri: '',
            nameButon_juri: '',
            actu_reg_juri: 0, //0 registrar - 1 actualizar
            listHijosConyugue: [],

        }
    },
    methods: {

        async guardar(){

            let me = this;

            var url = '/clientes-data-tratar/guardar';

            let post = {
                'id'     : this.$attrs.id,
                'form'   : this.form,
            };

            try {
                me.$pageLoad();
                let response        = await axios.post(url, post);
                var respuesta       = response.data;
                Swal.fire(respuesta.data, '', 'success');
                me.$pageLoad(true);

            } catch (error) {
                this.$mostrar_error(error);
            }
        },
        
        async traerDatos(){

            let me = this;

            var url = '/clientes-data-tratar/lista-opciones-editar';

            let post = {
                'id'   : this.$attrs.id,
            };

            try {
                me.$pageLoad();
                let response        = await axios.post(url, post);
                var respuesta       = response.data.data;

                //asignar
                me.lista_users          = respuesta.users
                me.lista_vehiculos      = respuesta.vehiculos
                me.lista_referencias    = respuesta.referencias
                me.lista_seguros        = respuesta.seguros
                me.lista_anios          = respuesta.anios
                me.lista_documentos     = respuesta.documentos
                me.lista_acti_econo     = respuesta.actividades_economicas
                //pasamos data
                if(respuesta.cliente !== null){
                    me.form.edad            = respuesta.cliente.edad
                }

                me.asignar(respuesta.datos,  me.form.edad);
                me.$pageLoad(true);

            } catch (error) {
                this.$mostrar_error(error);
            }
        },

        asignar(data, edad){

            //asesor
            if(data.asesor_id != null){
                this.form.user_id = data.asesor_id;
            }
            //vehiculo modelo
            if(data.tranferencia != null && data.tranferencia.idmodelo != null){
                this.form.vehiculo_id = data.tranferencia.idmodelo;
            }
            //Referencia
            if(data.referencia_id != null){
                this.form.referencia_id                        = data.referencia_id
                this.vaCreCliente.referencia                   = data.referencia_id
                this.crear_cliente_juridico.id_referencia      = data.referencia_id

            }
            //Seguro
            if(data.tranferencia != null && data.tranferencia.idseguro != null){
                this.form.seguro_id = data.tranferencia.idseguro;
            }

            this.form.estado        = data.estado
            this.form.telefono_1    = data.telefono_1
            this.form.telefono_2    = data.telefono_2
            //Año
            var anio = this.lista_anios.filter(e => e.anio == data.anio);

            if(anio[0] != null){
                this.form.anio_id           = anio[0].id
                this.form.anio              = anio[0].anio
            }

            this.form.placa             = data.placa
            this.form.valor_asgurado    = data.valor_asgurado
            this.form.tasa              = data.tasa
            this.form.fecha_inicio      = data.fecha_gestion
            this.form.fecha_fin         = data.vigencia_depoliza
            this.form.anio_antiguedad   = data.anio_antiguedad

            //crear cliente
            this.vaCreCliente.cNombre            = data.cliente
            this.vaCreCliente.fecha_nacimiento   = data.fecha_nacimiento
            this.vaCreCliente.cNumDoc            = data.cedula
            this.vaCreCliente.cDireccion         = data.direccion
            this.vaCreCliente.cTelefonoCliente   = data.telefono_1
            this.vaCreCliente.cEmail             = data.email

            this.crear_cliente_juridico.razon_social            = data.cliente
            this.crear_cliente_juridico.ruc                     = data.cedula
            this.crear_cliente_juridico.direccion               = data.direccion
            this.crear_cliente_juridico.correo                  = data.email

            this.crear_cliente_juridico.telefono_1              = data.telefono_1
            this.crear_cliente_juridico.telefono_2              = data.telefono_2
            this.crear_cliente_juridico.fecha_constitucion      = data.fecha_nacimiento

            this.cliente_estado           = data.tranferencia.cliente;

            if (this.cliente_estado) {
                if(data.tranferencia.cliente.nombre == null){
                    this.nombre_cliente          = data.tranferencia.cliente.razon_social;

                }else{
                    this.nombre_cliente          = data.tranferencia.cliente.nombre;
                }
            }

            if(this.form.tasa != null || this.form.tasa != 0){
                this.form.tasa = this.calcular_tasas(edad, this.form.anio_antiguedad, this.form.valor_asgurado)
            }

        },

        asignarAnio(event) {
            var anio = this.lista_anios.filter(e => e.id == event);
            this.form.anio              = anio[0].anio
        },

        abrirModalTipoCliente() {
            this.modal_show_tipo_cliente = !this.modal_show_tipo_cliente;
        },

        abrirModalNatural() {
            this.modalShowNatural = !this.modalShowNatural;

            if(this.modalShowNatural==true){

                this.tituloModal = "Registrar Cliente Natural";
                this.actu_reg = 0;
                this.nameButon = "Guardar";

            }
        },

        cleanVariables(){
            this.vaCreCliente.cNombre = "";
            this.vaCreCliente.referencia = "";
            this.vaCreCliente.cApellido = "";
            this.vaCreCliente.fecha_nacimiento = "";
            this.vaCreCliente.eId = "";
            this.vaCreCliente.cNumDoc = "";
            this.vaCreCliente.eIdDocumento = 1;
            this.vaCreCliente.referencia = 1;
            this.vaCreCliente.cDireccion = "";
            this.vaCreCliente.cTelefonoCliente = "";
            this.vaCreCliente.cEmail = "";
            this.vaCreCliente.idactividad_economica = 0;
            this.vaCreCliente.estado_civil = '';
            this.listHijosConyugue = [];
            this.vaCreCliente.hijos_cantidad = 0 ;
            this.vaCreCliente.nombre_conyugue = '';
            this.vaCreCliente.apellido_conyugue = '';
            this.vaCreCliente.fecha_nacimiento_conyugue = null;
            this.modalShowNatural = false;

        },

        calcularEdad(fecha) {
            if(fecha===null || fecha === ''){
                     return 0;
            }
            var hoy = new Date();
            var cumpleanos = new Date(fecha);
            var edad = hoy.getFullYear() - cumpleanos.getFullYear();
            var m = hoy.getMonth() - cumpleanos.getMonth();

            if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
                edad--;
            }
            if(edad < 0) {edad = 0;}

            return edad;
        },

        agregarHijosConyugue(){
            if(this.dataHijosConyugues.nombre === '' || this.dataHijosConyugues.apellido === '' || this.dataHijosConyugues.fecha_nacimiento === null ){
                this.notify(" " + 'Ingrese todos los datos del hijo a registrar',"","top","right","fas fa-exclamation-triangle","danger",'animated flipInX','flipOutX')
            }else{
                this.listHijosConyugue.push({
                    'id' : 0,
                    'nombre': this.dataHijosConyugues.nombre,
                    'apellido': this.dataHijosConyugues.apellido,
                    'cumpleanio' : this.dataHijosConyugues.fecha_nacimiento
                });

                this.dataHijosConyugues.nombre = '';
                this.dataHijosConyugues.apellido = '';
                this.dataHijosConyugues.fecha_nacimiento = null;
            }
        },

        eliminar_hijo(index){
            let me = this;
            me.listHijosConyugue.splice(index, 1);
        },

        setRegistrarCliente(){

            this.$pageLoad();
            var url = '/cliente/registrar';

            axios.post(url, {
                'nombre' :                  this.vaCreCliente.cNombre,
                'referencia' :              this.vaCreCliente.referencia,
                'apellido' :                this.vaCreCliente.cApellido,
                'documento':                this.vaCreCliente.eIdDocumento,
                'idreferencia':             this.vaCreCliente.referencia,
                'numdoc':                   this.vaCreCliente.cNumDoc,
                'direccion':                this.vaCreCliente.cDireccion,
                'telefono':                 this.vaCreCliente.cTelefonoCliente,
                'fecha_nacimiento':         this.vaCreCliente.fecha_nacimiento,
                'email':                    this.vaCreCliente.cEmail,
                'idactividad_economica':    this.vaCreCliente.idactividad_economica,
                'estado_civil':             this.vaCreCliente.estado_civil,
                'hijos_cantidad':           this.vaCreCliente.hijos_cantidad,
                'nombre_conyugue':          this.vaCreCliente.nombre_conyugue,
                'apellido_conyugue':        this.vaCreCliente.apellido_conyugue,
                'fecha_nacimiento_conyugue': this.vaCreCliente.fecha_nacimiento_conyugue,
                'arrayHijosConyugue' :      this.listHijosConyugue,
                'clientes_data_id'   :      this.$attrs.id

            }).then(res => {

                if(res.data.status){
                    console.log(res.data);

                    this.cliente_estado           = res.data.cliente;

                    if (this.cliente_estado) {
                        this.nombre_cliente          = res.data.cliente.fullname;
                        this.form.edad               = res.data.cliente.edad;
                        if(this.form.tasa != null || this.form.tasa != 0){
                            this.form.tasa = this.calcular_tasas(this.form.edad, this.form.anio_antiguedad, this.form.valor_asgurado)
                        }
                    }

                    this.$pageLoad(true);
                    this.cleanVariables();//Limpiamos el form
                    this.clearVariablesJuridico();
                    this.notify(" Cliente registrado con éxito","","top","center","fas fa-check-circle","success",' flipInX','flipOutX')

                }else if(res.data.errorTipo) {
                    this.$pageLoad(true);
                    this.notify(" Seleccione almenos un tipo de cliente","","top","right","fas fa-exclamation-triangle","danger",'animated flipInX','flipOutX')
                }

            })
            .catch(err => {
                this.$pageLoad(true);

               for(var key in err.response.data.errors){

                this.notify(" " + err.response.data.errors[key],"","top","right","fas fa-exclamation-triangle","danger",'animated flipInX','flipOutX')

               }
               if (err.response.status == 401) {
                        this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                       this.$pageLoad(true);
                    }
                console.error(err);
            })
        },

        setRegistrarClienteJuridico(){

            this.$pageLoad();
            var url = '/cliente/registrar-juridico';
            let me = this;

            axios.post(url, {
                'datos_general'         : me.crear_cliente_juridico,
                'representante_legal'   : me.crear_representante_legal,
                'hijos'                 : me.listHijosConyugue,
                'clientes_data_id'      : me.id
            }).then(res => {

                if(res.data.status){
                    this.cliente_estado           = res.data.cliente;

                    if (this.cliente_estado) {
                        this.nombre_cliente          = res.data.cliente.fullname;
                        this.form.edad               = res.data.cliente.edad;
                        if(this.form.tasa != null || this.form.tasa != 0){
                            this.form.tasa = this.calcular_tasas(this.form.edad, this.form.anio_antiguedad, this.form.valor_asgurado)
                        }
                    }

                   this.$pageLoad(true);
                    this.cleanVariables();//Limpiamos el form
                    this.clearVariablesJuridico();
                  if(this.actu_reg==1){
                       this.notify(" Cliente registrado con éxito","","top","center","fas fa-check-circle","success",' flipInX','flipOutX')
                       this.clienteCotizar();
                  }else{
                       this.notify(" Cliente actualizado con éxito","","top","center","fas fa-check-circle","success",' flipInX','flipOutX')
                  }

                }else{
                    this.$pageLoad(true);
                    this.notify("Error","","top","right","fas fa-exclamation-triangle","danger",'animated flipInX','flipOutX')
                }

            })
            .catch(err => {
                this.$pageLoad(true);

               for(var key in err.response.data.errors){

                this.notify(" " + err.response.data.errors[key],"","top","right","fas fa-exclamation-triangle","danger",'animated flipInX','flipOutX')

               }
               if (err.response.status == 401) {
                        this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                       this.$pageLoad(true);
                    }
                console.error(err);
            })
        },

        abrirModalJuridica() {
            this.modalShowJuridica = !this.modalShowJuridica;

            if(this.modalShowJuridica==true){

                this.tituloModal_juri = "Registrar Cliente Juridico";
                this.actu_reg_juri = 0;

            }else{
                this.detalle_2 = false;
            }
        },

        clearVariablesJuridico(){
            this.modalShowJuridica  = false;
            this.crear_cliente_juridico.razon_social                = '';
            this.crear_cliente_juridico.ruc                         = '';
            this.crear_cliente_juridico.direccion                   = '';
            this.crear_cliente_juridico.correo                      = '';
            this.crear_cliente_juridico.id_documento                = 3;
            this.crear_cliente_juridico.telefono_1                  = '';
            this.crear_cliente_juridico.telefono_2                  = '';
            this.crear_cliente_juridico.fecha_constitucion          = null;
            this.crear_cliente_juridico.id_actividad_economica      = 0;
            this.crear_cliente_juridico.id_referencia               = 0;
            this.crear_cliente_juridico.tipo                        = 2;
            this.crear_cliente_juridico.nombre_conyugue             = '';
            this.crear_cliente_juridico.apellido_conyugue           = '';
            this.crear_cliente_juridico.fecha_nacimiento_conyugue   = null;
            this.crear_cliente_juridico.hijos_cantidad              = 0;

            this.crear_representante_legal.nombre              = '';
            this.crear_representante_legal.apellido            = '';
            this.crear_representante_legal.documento           = '';
            this.crear_representante_legal.id_documento        = 0;
            this.crear_representante_legal.direccion           = '';
            this.crear_representante_legal.correo              = '';
            this.crear_representante_legal.telefono_1          = '';
            this.crear_representante_legal.telefono_2          = '';
            this.crear_representante_legal.fecha_nacimiento    = null;
            this.crear_representante_legal.estado_civil        = '';

            this.listHijosConyugue = [];
            this.vaCreCliente.hijos_cantidad = 0 ;
            this.vaCreCliente.nombre_conyugue = '';
            this.vaCreCliente.apellido_conyugue = '';
            this.vaCreCliente.fecha_nacimiento_conyugue = null;
        },

        calcular_tasas(edad_v, antiguedad_v, valor_asegurado_v){

            let edad = edad_v
            let antiguedad = antiguedad_v
            let valor_asegurado = valor_asegurado_v

            if(edad >= 18 && edad <= 25  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 70000 && valor_asegurado <= 100000) return 2.70
            if(edad >= 18 && edad <= 25  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 40000 && valor_asegurado <= 69999)  return 2.80
            if(edad >= 18 && edad <= 25  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 30000 && valor_asegurado <= 39999)  return 2.90
            if(edad >= 18 && edad <= 25  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 20000 && valor_asegurado <= 29999)  return 3.00
            if(edad >= 18 && edad <= 25  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 0     && valor_asegurado <= 19999)  return 3.10

            if(edad >= 18 && edad <= 25  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 70000 && valor_asegurado <= 100000) return 3.30
            if(edad >= 18 && edad <= 25  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 40000 && valor_asegurado <= 69999)  return 3.35
            if(edad >= 18 && edad <= 25  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 30000 && valor_asegurado <= 39999)  return 3.40
            if(edad >= 18 && edad <= 25  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 20000 && valor_asegurado <= 29999)  return 3.45
            if(edad >= 18 && edad <= 25  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 0     && valor_asegurado <= 19999)  return 3.50

            if(edad >= 18 && edad <= 25  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 70000 && valor_asegurado <= 100000) return 3.30
            if(edad >= 18 && edad <= 25  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 40000 && valor_asegurado <= 69999)  return 3.40
            if(edad >= 18 && edad <= 25  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 30000 && valor_asegurado <= 39999)  return 3.45
            if(edad >= 18 && edad <= 25  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 20000 && valor_asegurado <= 29999)  return 3.50
            if(edad >= 18 && edad <= 25  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 0     && valor_asegurado <= 19999)  return 3.60

            if(edad >= 18 && edad <= 25  && antiguedad >=  11 && antiguedad <=  15 &&  valor_asegurado >= 30000 && valor_asegurado <= 100000) return 4.30

            if(edad >= 18 && edad <= 25  && antiguedad >=  11 && antiguedad <=  15 &&  valor_asegurado >= 0     && valor_asegurado <= 29999)  return 5.00

            if(edad >= 26 && edad <= 32  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 70000 && valor_asegurado <= 100000) return 2.60
            if(edad >= 26 && edad <= 32  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 40000 && valor_asegurado <= 69999)  return 2.70
            if(edad >= 26 && edad <= 32  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 30000 && valor_asegurado <= 39999)  return 2.80
            if(edad >= 26 && edad <= 32  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 20000 && valor_asegurado <= 29999)  return 2.90
            if(edad >= 26 && edad <= 32  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 0     && valor_asegurado <= 19999)  return 3.00

            if(edad >= 26 && edad <= 32  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 70000 && valor_asegurado <= 100000) return 3.25
            if(edad >= 26 && edad <= 32  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 40000 && valor_asegurado <= 69999)  return 3.30
            if(edad >= 26 && edad <= 32  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 30000 && valor_asegurado <= 39999)  return 3.35
            if(edad >= 26 && edad <= 32  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 20000 && valor_asegurado <= 29999)  return 3.40
            if(edad >= 26 && edad <= 32  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 0     && valor_asegurado <= 19999)  return 3.45

            if(edad >= 26 && edad <= 32  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 70000 && valor_asegurado <= 100000) return 3.30
            if(edad >= 26 && edad <= 32  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 40000 && valor_asegurado <= 69999)  return 3.35
            if(edad >= 26 && edad <= 32  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 30000 && valor_asegurado <= 39999)  return 3.40
            if(edad >= 26 && edad <= 32  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 20000 && valor_asegurado <= 29999)  return 3.45
            if(edad >= 26 && edad <= 32  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 0     && valor_asegurado <= 19999)  return 3.50

            if(edad >= 26 && edad <= 32  && antiguedad >=  11 && antiguedad <=  15 &&  valor_asegurado >= 30000 && valor_asegurado <= 100000) return 4.20

            if(edad >= 26 && edad <= 32  && antiguedad >=  11 && antiguedad <=  15 &&  valor_asegurado >= 0     && valor_asegurado <= 29000)  return 4.80

            if(edad >= 33 && edad <= 40  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 70000 && valor_asegurado <= 100000) return 2.50
            if(edad >= 33 && edad <= 40  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 40000 && valor_asegurado <= 69999)  return 2.60
            if(edad >= 33 && edad <= 40  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 30000 && valor_asegurado <= 39999)  return 2.70
            if(edad >= 33 && edad <= 40  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 20000 && valor_asegurado <= 29999)  return 2.80
            if(edad >= 33 && edad <= 40  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 0     && valor_asegurado <= 19999)  return 2.90

            if(edad >= 33 && edad <= 40  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 70000 && valor_asegurado <= 100000) return 3.20
            if(edad >= 33 && edad <= 40  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 40000 && valor_asegurado <= 69999)  return 3.25
            if(edad >= 33 && edad <= 40  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 30000 && valor_asegurado <= 39999)  return 3.30
            if(edad >= 33 && edad <= 40  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 20000 && valor_asegurado <= 29999)  return 3.35
            if(edad >= 33 && edad <= 40  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 0     && valor_asegurado <= 19999)  return 3.40

            if(edad >= 33 && edad <= 40  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 70000 && valor_asegurado <= 100000) return 3.25
            if(edad >= 33 && edad <= 40  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 40000 && valor_asegurado <= 69999)  return 3.30
            if(edad >= 33 && edad <= 40  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 30000 && valor_asegurado <= 39999)  return 3.35
            if(edad >= 33 && edad <= 40  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 20000 && valor_asegurado <= 29999)  return 3.40
            if(edad >= 33 && edad <= 40  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 0     && valor_asegurado <= 19999)  return 3.45

            if(edad >= 33 && edad <= 40  && antiguedad >=  11 && antiguedad <=  15 &&  valor_asegurado >= 30000 && valor_asegurado <= 100000) return 4.10

            if(edad >= 33 && edad <= 40  && antiguedad >=  11 && antiguedad <=  15 &&  valor_asegurado >= 0     && valor_asegurado <= 29000)  return 4.70

            if(edad >= 41 && edad <= 75  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 70000 && valor_asegurado <= 100000) return 2.40
            if(edad >= 41 && edad <= 75  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 40000 && valor_asegurado <= 69999)  return 2.50
            if(edad >= 41 && edad <= 75  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 30000 && valor_asegurado <= 39999)  return 2.60
            if(edad >= 41 && edad <= 75  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 20000 && valor_asegurado <= 29999)  return 2.70
            if(edad >= 41 && edad <= 75  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 0     && valor_asegurado <= 19999)  return 2.80

            if(edad >= 41 && edad <= 75  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 70000 && valor_asegurado <= 100000) return 3.10
            if(edad >= 41 && edad <= 75  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 40000 && valor_asegurado <= 69999)  return 3.20
            if(edad >= 41 && edad <= 75  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 30000 && valor_asegurado <= 39999)  return 3.25
            if(edad >= 41 && edad <= 75  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 20000 && valor_asegurado <= 29999)  return 3.30
            if(edad >= 41 && edad <= 75  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 0     && valor_asegurado <= 19999)  return 3.35

            if(edad >= 41 && edad <= 75  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 70000 && valor_asegurado <= 100000) return 2.20
            if(edad >= 41 && edad <= 75  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 40000 && valor_asegurado <= 69999)  return 2.25
            if(edad >= 41 && edad <= 75  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 30000 && valor_asegurado <= 39999)  return 3.00
            if(edad >= 41 && edad <= 75  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 20000 && valor_asegurado <= 29999)  return 3.35
            if(edad >= 41 && edad <= 75  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 0     && valor_asegurado <= 19999)  return 3.40

            if(edad >= 41 && edad <= 75  && antiguedad >=  11 && antiguedad <=  15 &&  valor_asegurado >= 30000 && valor_asegurado <= 100000) return 4.00

            if(edad >= 41 && edad <= 75  && antiguedad >=  11 && antiguedad <=  15 &&  valor_asegurado >= 0     && valor_asegurado <= 29000)  return 4.50
            return 0

        },

        asignarTasa(){
            if(this.form.tasa != null || this.form.tasa != 0){
                 this.form.tasa = this.calcular_tasas(this.form.edad, this.form.anio_antiguedad, this.form.valor_asgurado)
             }
        }
    },
    mounted(){
        this.traerDatos()
    }
}
</script>

<style>

</style>
